import React from "react";

export const PageHeader = ({ title, subtitle, children, testId }) => (
  <div data-testid={testId} className="mb-6 flex flex-col gap-3 border-b border-[#1E2D4A] pb-5 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-400">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2 className={`text-xs font-semibold uppercase tracking-[0.14em] text-slate-400 ${className}`}>{children}</h2>
);

export const EmptyState = ({ icon: Icon, title, message, action, testId }) => (
  <div data-testid={testId} className="flex flex-col items-center justify-center rounded-xl border border-dashed border-[#2D3F62] bg-[#111A2E]/50 px-6 py-14 text-center">
    {Icon && <Icon className="mb-3 h-9 w-9 text-slate-600" strokeWidth={1.5} />}
    <div className="text-base font-semibold text-slate-200">{title}</div>
    {message && <div className="mt-1 max-w-md text-sm text-slate-500">{message}</div>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export const AwaitingData = ({ label = "Awaiting data" }) => (
  <span className="inline-flex items-center gap-1.5 rounded-md bg-slate-800/50 px-2 py-1 text-[11px] font-medium text-slate-400">
    <span className="h-1.5 w-1.5 rounded-full bg-slate-500" /> {label}
  </span>
);
